module.exports = __webpack_public_path__ + "img/J13311.80fdf78c.png";